package com.devsusana.portfolio.i18n

/**
 * Supported languages in the portfolio application.
 */
enum class AppLanguage(val code: String, val displayName: String, val flag: String) {
    EN("en", "English", "🇬🇧"),
    ES("es", "Español", "🇪🇸");

    fun opposite(): AppLanguage = if (this == EN) ES else EN
}
